export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface ComicItem {
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览全部韩漫作品' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line', description: '浪漫甜美的爱情故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界冒险旅程' },
  { slug: 'action', name: '动作', icon: 'ri-swap-box-line', description: '热血激燃动作漫画' },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦悬疑推理' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默欢乐日常' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-2-line', description: '深刻动人剧情佳作' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚恐怖刺激体验' },
];

export const comics: ComicItem[] = [
  {
    slug: 'secret-romance',
    title: '秘密恋爱手册',
    author: '金美英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20featuring%20two%20young%20lovers%20in%20Seoul%20cityscape%2C%20soft%20watercolor%20style%2C%20warm%20pink%20and%20peach%20tones%2C%20delicate%20linework%2C%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20clean%20simple%20background%20with%20soft%20bokeh%2C%20Korean%20webtoon%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '从小一起长大的青梅竹马，在成年后意外发现彼此隐藏的秘密感情。一部甜中带虐的都市爱情故事，讲述了两个人在友情与爱情之间的挣扎与选择。精致的画风与细腻的情感描写，让读者沉浸在这个温暖又心动的故事中。',
    rating: 4.8,
    views: 1250000,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['纯爱', '都市', '青梅竹马', '甜蜜'],
    chapters: [
      { id: 1, title: '第1话 重逢', number: 1, updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 心跳', number: 2, updatedAt: '2026-06-08' },
      { id: 3, title: '第3话 告白', number: 3, updatedAt: '2026-06-15' },
      { id: 4, title: '第4话 犹豫', number: 4, updatedAt: '2026-06-22' },
      { id: 5, title: '第5话 决定', number: 5, updatedAt: '2026-06-29' },
      { id: 6, title: '第6话 初吻', number: 6, updatedAt: '2026-07-06' },
      { id: 7, title: '第7话 风波', number: 7, updatedAt: '2026-07-13' },
      { id: 8, title: '第8话 真心', number: 8, updatedAt: '2026-07-20' },
      { id: 9, title: '第9话 守护', number: 9, updatedAt: '2026-07-27' },
      { id: 10, title: '第10话 永恒', number: 10, updatedAt: '2026-08-03' },
    ],
  },
  {
    slug: 'magic-academy',
    title: '魔法学院录',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20fantasy%20manhwa%20cover%20with%20a%20young%20wizard%20student%20holding%20a%20glowing%20magical%20staff%20in%20front%20of%20a%20grand%20academy%20building%2C%20mystical%20blue%20and%20purple%20energy%20swirling%2C%20detailed%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20background%2C%20soft%20gradient%20sky&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '在一个以魔法为尊的世界里，出身平凡的主角意外觉醒了传说中的双重魔法属性。进入顶级魔法学院后，他面临着来自贵族学员的挑战和隐藏在学院深处的古老秘密。宏大的世界观、精彩的魔法战斗，带您进入一个充满想象力的奇幻世界。',
    rating: 4.9,
    views: 2100000,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['魔法', '学院', '战斗', '成长'],
    chapters: [
      { id: 1, title: '第1话 觉醒', number: 1, updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 入学', number: 2, updatedAt: '2026-05-08' },
      { id: 3, title: '第3话 试炼', number: 3, updatedAt: '2026-05-15' },
      { id: 4, title: '第4话 对决', number: 4, updatedAt: '2026-05-22' },
      { id: 5, title: '第5话 秘密', number: 5, updatedAt: '2026-05-29' },
      { id: 6, title: '第6话 联盟', number: 6, updatedAt: '2026-06-05' },
      { id: 7, title: '第7话 遗迹', number: 7, updatedAt: '2026-06-12' },
      { id: 8, title: '第8话 真相', number: 8, updatedAt: '2026-06-19' },
    ],
  },
  {
    slug: 'shadow-hunter',
    title: '暗影猎人',
    author: '李东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Korean%20action%20manhwa%20cover%20showing%20a%20skilled%20hunter%20with%20twin%20daggers%20in%20a%20urban%20night%20setting%2C%20neon%20city%20lights%20reflecting%2C%20dynamic%20pose%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20dark%20background%2C%20sharp%20linework&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'action',
    description: '在暗影笼罩的现代都市中，存在着普通人不知道的猎人与魔物之间的战争。主角是一名S级暗影猎人，在追查一起连环失踪事件时，意外揭开了一个威胁整个城市存亡的巨大阴谋。紧张刺激的战斗场面，扣人心弦的悬疑剧情。',
    rating: 4.7,
    views: 1800000,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['都市', '战斗', '超能力', '悬疑'],
    chapters: [
      { id: 1, title: '第1话 暗影降临', number: 1, updatedAt: '2026-04-15' },
      { id: 2, title: '第2话 猎人之夜', number: 2, updatedAt: '2026-04-22' },
      { id: 3, title: '第3话 追踪', number: 3, updatedAt: '2026-04-29' },
      { id: 4, title: '第4话 交锋', number: 4, updatedAt: '2026-05-06' },
      { id: 5, title: '第5话 线索', number: 5, updatedAt: '2026-05-13' },
      { id: 6, title: '第6话 巢穴', number: 6, updatedAt: '2026-05-20' },
    ],
  },
  {
    slug: 'campus-diary',
    title: '校园日记',
    author: '郑秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20cheerful%20Korean%20comedy%20manhwa%20cover%20with%20a%20group%20of%20high%20school%20students%20laughing%20together%20in%20a%20classroom%20setting%2C%20colorful%20and%20lively%20atmosphere%2C%20cute%20chibi%20style%20elements%2C%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20background%2C%20pastel%20color%20palette&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'comedy',
    description: '平凡的高中生金多美转学到了一所奇葩云集的学校，在这里她遇到了各种各样的古怪同学和老师。从课堂上的爆笑日常到校园文化节的疯狂冒险，每一话都充满了令人捧腹的欢乐。轻松愉快的校园喜剧，治愈你的每一天。',
    rating: 4.6,
    views: 980000,
    status: '已完结',
    updatedAt: '2026-07-15',
    tags: ['校园', '日常', '搞笑', '青春'],
    chapters: [
      { id: 1, title: '第1话 转学生', number: 1, updatedAt: '2026-01-10' },
      { id: 2, title: '第2话 奇葩同学们', number: 2, updatedAt: '2026-01-17' },
      { id: 3, title: '第3话 学生会选举', number: 3, updatedAt: '2026-01-24' },
      { id: 4, title: '第4话 学园祭', number: 4, updatedAt: '2026-01-31' },
      { id: 5, title: '第5话 修学旅行', number: 5, updatedAt: '2026-02-07' },
      { id: 6, title: '第6话 毕业季', number: 6, updatedAt: '2026-02-14' },
    ],
  },
  {
    slug: 'mind-game',
    title: '心迷宫',
    author: '崔贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20Korean%20mystery%20manhwa%20cover%20with%20a%20detective%20standing%20in%20a%20foggy%20alleyway%20holding%20a%20flashlight%2C%20dark%20silhouettes%20in%20the%20background%2C%20rainy%20night%20mood%2C%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20background%2C%20noir%20aesthetic&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'mystery',
    description: '一位退休的心理学家被卷入了一系列离奇的失踪案件。每一起案件都与人类内心最深处的恐惧有关。通过精妙的心理分析和推理，他一步步接近真相，却发现真相远比想象的更加令人震惊。烧脑的悬疑剧情，保证让你欲罢不能。',
    rating: 4.9,
    views: 1560000,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['推理', '心理', '悬疑', '犯罪'],
    chapters: [
      { id: 1, title: '第1话 退休', number: 1, updatedAt: '2026-03-20' },
      { id: 2, title: '第2话 案件', number: 2, updatedAt: '2026-03-27' },
      { id: 3, title: '第3话 侧写', number: 3, updatedAt: '2026-04-03' },
      { id: 4, title: '第4话 迷宫', number: 4, updatedAt: '2026-04-10' },
      { id: 5, title: '第5话 突破', number: 5, updatedAt: '2026-04-17' },
      { id: 6, title: '第6话 反转', number: 6, updatedAt: '2026-04-24' },
      { id: 7, title: '第7话 真相', number: 7, updatedAt: '2026-05-01' },
    ],
  },
  {
    slug: 'tears-of-kingdom',
    title: '王国的眼泪',
    author: '尹智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20historical%20drama%20manhwa%20cover%20showing%20a%20princess%20in%20traditional%20hanbok%20standing%20in%20a%20palace%20courtyard%20with%20cherry%20blossoms%2C%20elegant%20and%20melancholy%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20soft%20lighting%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    description: '以一个虚构的古代王国为背景，讲述了公主在父王驾崩后被迫承担起拯救国家的重任。在权力斗争、外敌入侵的夹缝中，她展现出了非凡的智慧与勇气。史诗般的叙事、精美的画风，一部感人至深的历史剧情大作。',
    rating: 4.8,
    views: 1350000,
    status: '已完结',
    updatedAt: '2026-06-30',
    tags: ['古风', '宫廷', '权谋', '女性'],
    chapters: [
      { id: 1, title: '第1话 噩耗', number: 1, updatedAt: '2026-03-01' },
      { id: 2, title: '第2话 继位', number: 2, updatedAt: '2026-03-08' },
      { id: 3, title: '第3话 阴谋', number: 3, updatedAt: '2026-03-15' },
      { id: 4, title: '第4话 联军', number: 4, updatedAt: '2026-03-22' },
      { id: 5, title: '第5话 决战', number: 5, updatedAt: '2026-03-29' },
      { id: 6, title: '第6话 和平', number: 6, updatedAt: '2026-04-05' },
    ],
  },
  {
    slug: 'night-terror',
    title: '午夜惊魂',
    author: '姜太元',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20chilling%20Korean%20horror%20manhwa%20cover%20with%20a%20terrified%20person%20in%20a%20dark%20abandoned%20building%2C%20ghostly%20figure%20in%20the%20shadows%2C%20cold%20blue%20and%20gray%20tones%2C%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20dark%20background%2C%20creepy%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'horror',
    description: '一群大学生为了完成课题，进入了一座传说中的鬼宅。从踏入宅邸的那一刻起，诡异的事件接连发生。每一个人都开始看到不同的恐怖幻象，而这些幻象似乎与他们的过去有着某种联系。恐怖氛围营造极佳，胆小勿入。',
    rating: 4.5,
    views: 890000,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['恐怖', '灵异', '校园', '惊悚'],
    chapters: [
      { id: 1, title: '第1话 探险', number: 1, updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 异响', number: 2, updatedAt: '2026-06-08' },
      { id: 3, title: '第3话 身影', number: 3, updatedAt: '2026-06-15' },
      { id: 4, title: '第4话 噩梦', number: 4, updatedAt: '2026-06-22' },
      { id: 5, title: '第5话 逃离', number: 5, updatedAt: '2026-06-29' },
    ],
  },
  {
    slug: 'love-in-seoul',
    title: '首尔爱情故事',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20with%20a%20couple%20walking%20along%20the%20Han%20River%20at%20sunset%20in%20Seoul%2C%20warm%20golden%20light%2C%20beautiful%20city%20skyline%2C%20Korean%20webtoon%20art%20style%2C%20soft%20romantic%20mood%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'romance',
    description: '两个在首尔打拼的年轻人，在偌大的城市中偶然相遇。从咖啡店的偶然对望，到汉江边的并肩漫步，一段真实而温暖的都市爱情故事徐徐展开。贴近生活的剧情让每一位在都市中奋斗的读者都能找到共鸣。',
    rating: 4.7,
    views: 1680000,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['都市', '恋爱', '日常', '治愈'],
    chapters: [
      { id: 1, title: '第1话 偶遇', number: 1, updatedAt: '2026-05-10' },
      { id: 2, title: '第2话 咖啡', number: 2, updatedAt: '2026-05-17' },
      { id: 3, title: '第3话 约会', number: 3, updatedAt: '2026-05-24' },
      { id: 4, title: '第4话 误会', number: 4, updatedAt: '2026-05-31' },
      { id: 5, title: '第5话 和解', number: 5, updatedAt: '2026-06-07' },
      { id: 6, title: '第6话 承诺', number: 6, updatedAt: '2026-06-14' },
    ],
  },
];

export const getComicsByCategory = (categorySlug: string): ComicItem[] => {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
};

export const getComicBySlug = (slug: string): ComicItem | undefined => {
  return comics.find((c) => c.slug === slug);
};

export const getHotComics = (limit: number = 6): ComicItem[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getNewUpdates = (limit: number = 8): ComicItem[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};